module.exports = __webpack_public_path__ + "static/media/1POLICY26.7ff14622.jpg";